import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import {
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  DATADOG_IS_ENABLED,
  DATADOG_SAMPLE_RATE,
  DATADOG_SERVICE,
  DATADOG_SESSION_REPLAY_SAMPLE_RATE,
  TRACK,
} from '../../../config/env';

/**
 * URL segments of third party tools that must be excluded for more accuracy
 * for Datadog to determine page activity. Basically, requests going to URLs
 * that contain these segments will be ignored.
 *
 * @see https://gitlab.com/mindtickle/mt-shell/-/blob/track/prod/packages/ui-shell/src/components/Datadog/components/InitializeDatadog.ts#L8
 */
const thirdPartyUrlSegments = [
  'api.appcues.net',
  'edge.fullstory.com',
  'fast.appcues.com',
  'ingest.sentry.io',
  'intercom.io',
  'rs.fullstory.com',
  'zipy.ai',
];

const withDataDog =
  (ComponentDefinition: React.ComponentType) => (props: any) => {
    useEffect(() => {
      const isEnabled = DATADOG_IS_ENABLED;
      if (!(DATADOG_APPLICATION_ID && DATADOG_CLIENT_TOKEN && isEnabled)) {
        return;
      }

      datadogRum.init({
        applicationId: DATADOG_APPLICATION_ID,
        clientToken: DATADOG_CLIENT_TOKEN,
        defaultPrivacyLevel: 'mask-user-input',
        env: TRACK,
        service: DATADOG_SERVICE,
        sessionReplaySampleRate: DATADOG_SESSION_REPLAY_SAMPLE_RATE,
        sessionSampleRate: DATADOG_SAMPLE_RATE,
        site: 'datadoghq.com',
        trackFrustrations: true,
        trackInteractions: true,
        trackLongTasks: true,
        trackResources: true,
        trackUserInteractions: true,
        useSecureSessionCookie: true,
        allowedTracingUrls: [
          {
            match: (origin: string) => origin.includes('mindtickle.com'),
            propagatorTypes: ['tracecontext', 'datadog'],
          },
        ],
        excludedActivityUrls: [
          (url) =>
            thirdPartyUrlSegments.some((urlSegment) =>
              url.includes(urlSegment)
            ),
        ],
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <ComponentDefinition {...props} />;
  };

export default withDataDog;
